module.exports = __webpack_public_path__ + "img/minoriko aki_lw.a747383f.png";